import { app } from '../app'
import { createApp } from 'vue'
import { vuetify } from '../vuetify'
import { errorMixin } from '../mixins/error-mixin'
import { i18n } from '../i18n'
import VFormVoucher from '../components/VFormVoucher.vue'

createApp({
  components: {
    VFormVoucher
  },
  extends: app,
  mixins: [errorMixin]
})
  .use(vuetify)
  .use(i18n)
  .mount('#app')
